import React, { useEffect, useState } from "react";
import {
  AppBar,
  Toolbar,
  IconButton,
  Menu,
  MenuItem,
  Fab,
} from "@material-ui/core";
import {
  Menu as MenuIcon,
  Person as AccountIcon,
  Send as SendIcon,
  ExitToApp as Logout,
  Feedback, 
  Payment,
  Help
} from "@material-ui/icons";
import CalendarTodayIcon from '@material-ui/icons/CalendarToday';
import classNames from "classnames";
import Cookies from 'universal-cookie';
import moment from "moment";

// styles
import useStyles from "./styles";

// components
import { Typography } from "../Wrappers/Wrappers";
import Notification from "../Notification/Notification";
import UserAvatar from "../UserAvatar/UserAvatar";

// context
import {
  useLayoutState,
  useLayoutDispatch,
  toggleSidebar,
} from "../../context/LayoutContext";
import { useUserDispatch, signOut } from "../../context/UserContext";
import getClient from "../../services/getClient";
import translateString from "../../utils/Locales";
import { GoogleLogin } from 'react-google-login';
import { gapi } from 'gapi-script';
import getGoogleRefresh from "../../services/getGoogleRefreshToken";
import getAccessToken from "../../services/getGoogleToken";

const messages = [
  {
    id: 0,
    variant: "warning",
    name: "Jane Hew",
    message: "Hey! How is it going?",
    time: "9:32",
  },
  {
    id: 1,
    variant: "success",
    name: "Lloyd Brown",
    message: "Check out my new Dashboard",
    time: "9:18",
  },
  {
    id: 2,
    variant: "primary",
    name: "Mark Winstein",
    message: "I want rearrange the appointment",
    time: "9:15",
  },
  {
    id: 3,
    variant: "secondary",
    name: "Liana Dutti",
    message: "Good news from sale department",
    time: "9:09",
  },
];

const notifications = [
  { id: 0, color: "warning", message: "Check out this awesome ticket" },
  {
    id: 1,
    color: "success",
    type: "info",
    message: "What is the best way to get ...",
  },
  {
    id: 2,
    color: "secondary",
    type: "notification",
    message: "This is just a simple notification",
  },
  {
    id: 3,
    color: "primary",
    type: "e-commerce",
    message: "12 new orders has arrived today",
  },
];

let t = translateString;

export default function Header(props) {
  var classes = useStyles();

  const cookies = new Cookies();
  var username = cookies.get('username', { path: '/' });
  var token = cookies.get('token', { path: '/' });
  var db = cookies.get('db', { path: '/' });
  var dbPath = cookies.get('db_path', { path: '/' });

  // global
  var layoutState = useLayoutState();
  var layoutDispatch = useLayoutDispatch();
  var userDispatch = useUserDispatch();

  // local
  var [mailMenu, setMailMenu] = useState(null);
  var [notificationsMenu, setNotificationsMenu] = useState(null);
  var [profileMenu, setProfileMenu] = useState(null);
  var [client, setClient] = useState(null);
  const [googleLogin, setGoogleLogin] = useState(false);
  const [daysLeft, setDaysLeft] = useState(undefined);
  
  useEffect(() => {
    getCurrentClient();

    function start() {
      gapi.client.init({
        apiKey: 'AIzaSyCZhvxNOXSc5Q-Av_d9f6SEDqpubRBH8-4',
        clientId: "656471515583-qiupck5f2a3cuod1j9kdvl08gfp4jfqr.apps.googleusercontent.com",
        scope: 'openid email profile https://www.googleapis.com/auth/calendar',
        plugin_name: 'AppiusAcademy'
      });
    }

    gapi.load('client:auth2', start);

    checkGoogleLogin();
  }, []);

  const checkGoogleLogin = async () => {

    const cookies = new Cookies();
    let client = await getClient('', '', cookies.get('db', { path: '/' }));
    // if (client === null) {
    //   signOut(userDispatch, props.history);
    // }
    if (!client.g_refresh_token) {
      setGoogleLogin(true);
    } else {
      // Check token

      let username = cookies.get('username', { path: '/' });
      let token = cookies.get('token', { path: '/' });

      let check = await getAccessToken(username, token, client.g_refresh_token);
      if (check && check.result === 'ok') {
        window.sessionStorage.setItem('gtok', check.access_token);
        gapi.client.setToken({ access_token: check.access_token });
        setGoogleLogin(false);
      } else {
        setGoogleLogin(true);
        window.sessionStorage.removeItem('gtok');
      }
    }
  }

  const getCurrentClient = async () => {
    const c = await getClient(username, token, db);

    if (c != null) {
      if (c.is_expirable === '1') {
        const startDate = moment(c.startDate, "DD/MM/yyyy");
        const endDate = startDate.add(30, 'days');
        const today = moment().startOf('day');
  
        var rem = moment.duration(endDate.diff(today)).asDays();
        if (rem < 0) {
          signOut(userDispatch, props.history);
        } 
        setDaysLeft(rem);
      }
      
      setClient(c);
    }
  }

  const userType = window.sessionStorage.getItem('user_type');

  const handleSuccess = async response => {

    const cookies = new Cookies();
    let username = cookies.get('username', { path: '/' });
    let token = cookies.get('token', { path: '/' });

    let res = await getGoogleRefresh(username, token, response.code);
    if (res && res.result === 'ok') {
      let cliente = await getClient('', '', cookies.get('db', { path: '/' }));
      
      let tok = await getAccessToken(username, token, cliente.g_refresh_token);
      if (tok && tok.result === 'ok') {
        window.sessionStorage.setItem('gtok', tok.access_token);
        setGoogleLogin(false);
        gapi.client.setToken({ access_token: tok.access_token });
      }
    }
  };

  const handleFailure = error => {
    console.log(error);
  }

  return (
    <AppBar position="fixed" className={classes.appBar}>
      <Toolbar className={classes.toolbar}>
        <IconButton
          onClick={() => toggleSidebar(layoutDispatch)}
          className={classNames(
            classes.headerMenuButton,
            classes.headerMenuButtonCollapse,
          )}
        >
          {layoutState.isSidebarOpened ? (
            <MenuIcon
            classes={{
              root: classNames(
                classes.headerIcon,
                classes.headerIconCollapse,
              ),
            }}
          />
          ) : (
            <MenuIcon
              classes={{
                root: classNames(
                  classes.headerIcon,
                  classes.headerIconCollapse,
                ),
              }}
            />
          )}
        </IconButton>
        <Typography variant="h6" weight="medium" className={classes.logotype} color={'#000000'}>
          {client && client.ragioneSociale.toUpperCase()}
        </Typography>
        <Typography variant="h6" weight="medium" className={classes.logotype} style={{marginLeft: '20px'}}>
          { (userType == 0 || userType == 4) ? t('amministrazione') : userType == 1 ? t('studente') : userType == 2 ? t('professore') : '' }
        </Typography>
        <div className={classes.grow} />
        {/* <div id="signInDiv" /> */}
        { (false /*&& googleLogin*/) && <div style={{ marginRight: 100 }}><GoogleLogin
          clientId="656471515583-qiupck5f2a3cuod1j9kdvl08gfp4jfqr.apps.googleusercontent.com"
          theme="light"
          onSuccess={handleSuccess}
          onFailure={handleFailure}
          cookiePolicy={'single_host_origin'}
          responseType="code"
          accessType="offline"
          redirectUri="https://www.Hdemia.cloud"
          scope="openid email profile https://www.googleapis.com/auth/calendar" /></div> }         
        <IconButton
          aria-haspopup="true"
          color="inherit"
          className={classes.headerMenuButton}
          aria-controls="profile-menu"
          onClick={() => {
            
            let add = window.location.hash.replace('#/app/', '');
            props.openHelp(add);
          }}
        >
          <Help style={{ width: 25, height: 25 }} classes={{ root: classes.headerIcon }} />
        </IconButton>
        <IconButton
          aria-haspopup="true"
          color="inherit"
          className={classes.headerMenuButton}
          aria-controls="profile-menu"
          onClick={e => setProfileMenu(e.currentTarget)}
        >
          <AccountIcon classes={{ root: classes.headerIcon }} />
        </IconButton>
        <Menu
          id="mail-menu"
          open={Boolean(mailMenu)}
          anchorEl={mailMenu}
          onClose={() => setMailMenu(null)}
          MenuListProps={{ className: classes.headerMenuList }}
          className={classes.headerMenu}
          classes={{ paper: classes.profileMenu }}
          disableAutoFocusItem
        >
          <div className={classes.profileMenuUser}>
            <Typography variant="h4" weight="medium">
              New Messages
            </Typography>
            <Typography
              className={classes.profileMenuLink}
              component="a"
              color="secondary"
            >
              {messages.length} New Messages
            </Typography>
          </div>
          {messages.map(message => (
            <MenuItem key={message.id} className={classes.messageNotification}>
              <div className={classes.messageNotificationSide}>
                <UserAvatar color={message.variant} name={message.name} />
                <Typography size="sm" color="text" colorBrightness="secondary">
                  {message.time}
                </Typography>
              </div>
              <div
                className={classNames(
                  classes.messageNotificationSide,
                  classes.messageNotificationBodySide,
                )}
              >
                <Typography weight="medium" gutterBottom>
                  {message.name}
                </Typography>
                <Typography color="text" colorBrightness="secondary">
                  {message.message}
                </Typography>
              </div>
            </MenuItem>
          ))}
          <Fab
            variant="extended"
            color="primary"
            aria-label="Add"
            className={classes.sendMessageButton}
          >
            Send New Message
            <SendIcon className={classes.sendButtonIcon} />
          </Fab>
        </Menu>
        <Menu
          id="notifications-menu"
          open={Boolean(notificationsMenu)}
          anchorEl={notificationsMenu}
          onClose={() => setNotificationsMenu(null)}
          className={classes.headerMenu}
          disableAutoFocusItem
        >
          {notifications.map(notification => (
            <MenuItem
              key={notification.id}
              onClick={() => setNotificationsMenu(null)}
              className={classes.headerMenuItem}
            >
              <Notification {...notification} typographyVariant="inherit" />
            </MenuItem>
          ))}
        </Menu>
        <Menu
          id="profile-menu"
          open={Boolean(profileMenu)}
          anchorEl={profileMenu}
          onClose={() => setProfileMenu(null)}
          className={classes.headerMenu}
          classes={{ paper: classes.profileMenu }}
          disableAutoFocusItem
        >
          <div className={classes.profileMenuUser} >
            <Typography style={{ display: 'flex', justifyContent: 'space-between' }} variant="h4" weight="medium">
              <div>
                {username}
              </div>
              <div className={classes.textEnd}>
                {daysLeft !== undefined && (<CalendarTodayIcon style={{marginTop: '5px'}} />)}{daysLeft}
              </div>
            </Typography>
            <Typography
              className={classes.profileMenuLink}
              component="a"              
            >
            </Typography> 
            
          </div>
          <MenuItem
            className={classNames(
              classes.headerMenuItem,
            )} onClick={() => {
              setProfileMenu(null);
              window.location.href= '/' + dbPath + '/#/app/usersettings';
            }}>
            <AccountIcon className={classes.profileMenuIcon} /> {t('profilo')}
          </MenuItem>
          { props.isAdmin && <MenuItem
            className={classNames(
              classes.headerMenuItem,
            )} onClick={() => {
              setProfileMenu(null);
              window.location.href= '/' + dbPath + '/#/app/account';
            }}>
            <Payment className={classes.profileMenuIcon} /> {t('gestione_account')}
          </MenuItem> }
          { props.isAdmin && <MenuItem
            className={classNames(
              classes.headerMenuItem,
            )} onClick={() => {
              setProfileMenu(null);
              window.location.href= '/' + dbPath + '/#/app/sendFeedback';
            }}>
            <Feedback className={classes.profileMenuIcon} /> {t('assistenza')}
          </MenuItem>
          }
          <MenuItem
            className={classNames(
              classes.headerMenuItem,
            )} onClick={() => {
              setProfileMenu(null);
              signOut(userDispatch, props.history);
            }}
          >
            <Logout className={classes.profileMenuIcon} /> {t('esci')}
          </MenuItem>
        </Menu>
      </Toolbar>
    </AppBar>
  );
}
